import React, { useState } from "react";
import styles from "./CourseManagement.module.css";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import { useEffect } from "react";
import ListCourseInfo from "./ListCourseInfo";
import ListSubjectInfo from "./ListSubjectInfo";
import ListTestTopicInfo from "./ListTestTopicInfo";

function CourseManagement() {
  const navigate = useNavigate();
  const { active_tab } = useParams();
  const [activeTab, setActiveTab] = useState(1);
  useEffect(() => {
    setActiveTab(Number(active_tab) || 1);
  }, [active_tab]);

  const handleTabClick = (index) => {
    setActiveTab(index);
    navigate(`/CourseManagement/${index}`);
  };

  return (
    <div className={`${styles.cm_container} BathHeader`} >
      {/* <h6 className={`${styles.cm_title} ms-0 me-0`}></h6> */}
      <div className="col-md-6 col-12">
          <h2 className="TitleHeader">Course Management</h2>
        </div>
      <div className="row">
        <div className="col-md-12">
          {/* nav-tabs */}
          <ul
            className="nav cm_nav-fill mb-3"
            id="cm_listViewTabs"
            role="tablist"
          >
            <li className="nav-item" role="presentation">
              <a
                className={activeTab === 1 ? "nav-link active" : "nav-link"}
                // id="ex2-tab-1"
                data-mdb-toggle="tab"
                href="javascript:void(0)"
                role="tab"
                aria-controls="ex2-tabs-1"
                aria-selected={activeTab === 1}
                onClick={() => handleTabClick(1)}
              >
                Courses
              </a>
            </li>
            <li className="nav-item" role="presentation">
              <a
                className={activeTab === 2 ? "nav-link active" : "nav-link"}
                // id="ex2-tab-2"
                data-mdb-toggle="tab"
                href="javascript:void(0)"
                role="tab"
                aria-controls="ex2-tabs-2"
                aria-selected={activeTab === 2}
                onClick={() => handleTabClick(2)}
              >
                Subjects
              </a>
            </li>
            <li className="nav-item" role="presentation">
              <a
                className={activeTab === 3 ? "nav-link active" : "nav-link"}
                // id="ex2-tab-3"
                data-mdb-toggle="tab"
                href="javascript:void(0)"
                role="tab"
                aria-controls="ex2-tabs-3"
                aria-selected={activeTab === 3}
                onClick={() => handleTabClick(3)}
              >
                 Topics
              </a>
            </li>
          </ul>
        </div>
        {/* <div className="borderActive"></div> */}
      </div>
      {/* Tab content */}
      {activeTab === 1 && <ListCourseInfo />}
      {activeTab === 2 && <ListSubjectInfo />}
      {activeTab === 3 && <ListTestTopicInfo />}
    </div>
  );
}

export default CourseManagement;
